import type { CreateTypeOfCallSopReportMappingDto, TypeOfCallSopReportMappingDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { DataRequestDto, EntitySchemaDto, IdNameDto, PageRequestDto } from '../models';
import type { SopReportListDto } from '../sop-reports/models';

@Injectable({
  providedIn: 'root',
})
export class TypeOfCallSopReportMappingService {
  apiName = 'Default';
  

  create = (input: CreateTypeOfCallSopReportMappingDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopReportMappingDto>({
      method: 'POST',
      url: '/api/app/type-of-call-sop-report-mapping',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/type-of-call-sop-report-mapping/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopReportMappingDto>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-report-mapping/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getAllSopReports = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, SopReportListDto[]>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-report-mapping/sop-reports',
    },
    { apiName: this.apiName,...config });
  

  getCount = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-report-mapping/count',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getDropDownOptions = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdNameDto>>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-report-mapping/drop-down-options',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getExpandById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopReportMappingDto[]>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-report-mapping/${id}/expand`,
    },
    { apiName: this.apiName,...config });
  

  getExtraPropertiesById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Record<string, object>>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-report-mapping/${id}/extra-properties`,
    },
    { apiName: this.apiName,...config });
  

  getIds = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-report-mapping/ids',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<TypeOfCallSopReportMappingDto>>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-report-mapping',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByTypeOfCall = (typeOfCallId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopReportMappingDto[]>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-report-mapping/by-type-of-call/${typeOfCallId}`,
    },
    { apiName: this.apiName,...config });
  

  getOneExtraPropertiesByIdAndKey = (id: string, key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, object>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-report-mapping/${id}/one-extra-properties`,
      params: { key },
    },
    { apiName: this.apiName,...config });
  

  getSchema = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntitySchemaDto>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-report-mapping/schema',
    },
    { apiName: this.apiName,...config });
  

  getWithDetails = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopReportMappingDto>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-report-mapping/${id}/with-details`,
    },
    { apiName: this.apiName,...config });
  

  setExtraPropertiesByIdAndKeyAndValue = (id: string, key: string, value: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/type-of-call-sop-report-mapping/${id}/set-extra-properties`,
      params: { key, value },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: CreateTypeOfCallSopReportMappingDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopReportMappingDto>({
      method: 'PUT',
      url: `/api/app/type-of-call-sop-report-mapping/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
